/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["few","many","one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    const v = decimalPart.length;
    if (isOrdinal) {
    }
    else {
        if (v === 0 && (((((i % 100) === 0 || (i % 100) === 20) || (i % 100) === 40) || (i % 100) === 60) || (i % 100) === 80))
            return "few";
        if (v !== 0)
            return "many";
        if (v === 0 && (i % 10) === 1)
            return "one";
        if (v === 0 && (i % 10) === 2)
            return "two";
    }
    return "other";
}},"locale":"gv"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["few","many","one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    const v = decimalPart.length;
    if (isOrdinal) {
    }
    else {
        if (v === 0 && (((((i % 100) === 0 || (i % 100) === 20) || (i % 100) === 40) || (i % 100) === 60) || (i % 100) === 80))
            return "few";
        if (v !== 0)
            return "many";
        if (v === 0 && (i % 10) === 1)
            return "one";
        if (v === 0 && (i % 10) === 2)
            return "two";
    }
    return "other";
}},"locale":"gv"})
}
